/**
 * Main JavaScript Entry Point
 * 
 * Vanilla JavaScript only - no jQuery dependency
 * Uses modern ES6+ features
 */

// Import CSS (Vite will handle this)
import '../css/style.css';

// Import and initialize GSAP (makes it globally available)
import './gsap-init.js';

// Import navigation functionality
import './navigation.js';

// Import WooCommerce cart updates
import './woocommerce-cart.js';

// Carousel (Swiper) is provided by vooruitzicht-theme-core (vtc-carousel).

// Import hero block aspect ratio handler
import './hero-block.js';

// Import accordion functionality
import './accordion.js';

// Import modal handler
import './modal-handler.js';

// Import gallery block functionality
import './gallery-block.js';

// Project grid filters
import './project-grid-block.js';

// News grid (AJAX + shareable URLs)
import './news-list-block.js';

// Import scroll animations (subtle GSAP ScrollTrigger)
import './scroll-animations.js';

// Import back to top button
import './back-to-top.js';

// Import contact CTA button
import './contact-cta.js';

import './clickdimensions-hidden-fields.js';
import './property-inquiry-contact.js';
import { initFacetwpListingLoader } from './facetwp-listing-loader.js';

/**
 * Initialize the theme
 */
class RegattaTheme {
	constructor() {
		this.init();
	}
	
	init() {
		// Wait for DOM to be ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.onReady());
		} else {
			this.onReady();
		}
	}
	
	onReady() {
		// Initialize components
		// this.initNavigation();
		this.initAccessibility();
		initFacetwpListingLoader();

		window.visualViewport.addEventListener('resize', () => {
			this.setExactVh();
		});

		this.setExactVh();
	}

	setExactVh() {
		const height = window.visualViewport
			? window.visualViewport.height
			: document.documentElement.clientHeight;

		document.documentElement.style.setProperty('--actual-viewport-height', `${height * 0.01}px`);
	}
	
	/**
	 * Initialize accessibility features
	 */
	initAccessibility() {
		// Skip link functionality
		const skipLink = document.querySelector('.skip-link');
		if (skipLink) {
			skipLink.addEventListener('click', (e) => {
				e.preventDefault();
				const target = document.querySelector(skipLink.getAttribute('href'));
				if (target) {
					target.focus();
					target.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
		
		// Keyboard navigation for custom elements
		this.initKeyboardNavigation();
	}
	
	/**
	 * Initialize keyboard navigation
	 */
	initKeyboardNavigation() {
		// Handle Escape key for closing modals/dropdowns
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				// Close any open dropdowns or modals
				const openElements = document.querySelectorAll('[aria-expanded="true"]');
				openElements.forEach((element) => {
					element.setAttribute('aria-expanded', 'false');
				});
			}
		});
	}
}

// Initialize theme
new RegattaTheme();

// Export for use in other modules if needed
export default RegattaTheme;

